import { MemberProps } from 'app/components/Core/convention'
import KForm from 'app/components/Modules/Form/KForm'
import KInputText from 'app/components/Modules/Form/KInputText'
import { KFormProps } from 'app/components/Modules/Form/typing'
import Icon from 'app/components/UI-Elements/General/Icon'
import { RecordType } from 'app/constants/GlobalTypes'
import * as React from 'react'

const PasswordRequestForm: React.FC<MemberProps<IUser, Partial<KFormProps<IUser>>>> = ({
  props = {}
}) => {
  return (
    <KForm
      inlineErrors
      forceAction="create"
      recordType={RecordType.password_request}
      layout="vertical"
      {...props}>
      <KInputText
        name="email"
        type="email"
        rules={[{ type: 'email' }]}
        required
        suffix={<Icon type="user" />}
      />
    </KForm>
  )
}

export default PasswordRequestForm
